import styled from "styled-components";

export default styled.div`
  display: grid;
  gap: ${(props) => props.gap};
  align-content: ${(props) => props.alignContent || "space-between"};
  justify-content: center;
  position: relative;
  width: ${(props) => props.width || "100%"};
  height: ${(props) => props.height || "100%"};
  padding: ${props => props.padding || ""};
  ${(props) => props.style}
`;
